import { RouteConfig } from 'vue-router'
const CardDrawSportsShowIndex = () => import('../activity/202405/card-draw-sports-show/Index.vue')

export const A202405CardDrawSportsShowIndex: RouteConfig = {
  path: '/activity/202405/card-draw-sports-show',
  name: 'activity_202405_card_draw_sports_show',
  component: CardDrawSportsShowIndex,
  meta: {
    title: '集卡领运动秀',
    expiryDate: '2024-07-30',
  },
  props: (route) => ({ ...route.query }),
}

export default [A202405CardDrawSportsShowIndex]
